/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Sign_In_ButtonInputs */



/**
* | output |
* | --- |
* | "Sign In" |
*
* @param {Login_Sign_In_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_sign_in_button = /** @type {((inputs?: Login_Sign_In_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Sign_In_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Se Connecter")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anmelden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registrazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Войти")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciar sesión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("登入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サインイン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दाखिल करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Entrar")
	return /** @type {LocalizedString} */ ("Sign In")
});